import {Person} from '../model/person.model'

export const getPersonName = (person: Person | undefined, length?: number | undefined) => {

	if (!person || !person.first_name || !person.last_name) {
		return undefined
	}

	const totalLength = person.first_name.length + person.last_name.length

	// if the composed name is shorter than defined length return the full name
	// if no length is defined, take 20 ad default value
	const stringLength = length !== undefined ? length : 20

	if (totalLength < stringLength) {
		return person.first_name + ' ' + person.last_name
	}
	// if name is longer shorten the first name return first Letter of firstname and lastname

	return person.first_name.charAt(0) + '. ' + person.last_name
}

export const getPersonFullName = (person: Person | undefined) => {
	if (person === undefined) {
		return undefined
	}

	return person?.first_name + ' ' + person.last_name

//    return person?.firstName + ' ' + getMiddleName(person.middle_name) + ' ' + person.lastName;
}
//
// const getMiddleName = (middle_name: string | undefined) => {
//     if (middle_name === undefined) {
//         return '';
//     }
//     return middle_name.charAt(0) + '.';
// }